import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { formatCurrency, formatNumber } from 'utils/formats';
import { TradingOffersSummary } from 'types/TradingOffer';

type EquityMarketAdminPanelSummaryCardProps = {
  sellOffersSummary: TradingOffersSummary;
  buyOffersSummary: TradingOffersSummary;
  pendingOperationsCount: number;
};

const EquityMarketAdminPanelSummaryCard: FC<
  EquityMarketAdminPanelSummaryCardProps
> = ({ sellOffersSummary, buyOffersSummary, pendingOperationsCount }) => {
  const { t } = useTranslate();

  return (
    <div className="nk-block">
      <div className="row g-gs">
        <div className="col-sm-4">
          <div className="card card-bordered" style={{ borderLeft: '3px solid #1ee0ac' }}>
            <div className="card-inner py-3">
              <h6 className="overline-title text-soft mb-1">
                {t('SellOffers')}
              </h6>
              <h4 className="mb-1">
                {formatCurrency(sellOffersSummary.totalAmount)}
              </h4>
              <p className="text-soft fs-13px mb-0">
                {sellOffersSummary.offersCount} {t('Offers').toLowerCase()} ·{' '}
                {formatNumber(sellOffersSummary.sharesCount)}{' '}
                {t('Shares').toLowerCase()}
              </p>
            </div>
          </div>
        </div>

        <div className="col-sm-4">
          <div className="card card-bordered" style={{ borderLeft: '3px solid #6576ff' }}>
            <div className="card-inner py-3">
              <h6 className="overline-title text-soft mb-1">
                {t('BuyOffers')}
              </h6>
              <h4 className="mb-1">
                {formatCurrency(buyOffersSummary.totalAmount)}
              </h4>
              <p className="text-soft fs-13px mb-0">
                {buyOffersSummary.offersCount} {t('Offers').toLowerCase()} ·{' '}
                {formatNumber(buyOffersSummary.sharesCount)}{' '}
                {t('Shares').toLowerCase()}
              </p>
            </div>
          </div>
        </div>

        <div className="col-sm-4">
          <div className="card card-bordered" style={{ borderLeft: '3px solid #f4bd0e' }}>
            <div className="card-inner py-3">
              <h6 className="overline-title text-soft mb-1">
                {t('PendingOperations')}
              </h6>
              <h4 className="mb-1">{pendingOperationsCount}</h4>
              <p className="text-soft fs-13px mb-0">
                {t('PendingOperationsDescription')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EquityMarketAdminPanelSummaryCard;
